/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Editor_Step_TimerInputs */

const en_editor_step_timer = /** @type {(inputs: Editor_Step_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer: ${i?.duration}`)
};

const de_editor_step_timer = /** @type {(inputs: Editor_Step_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer: ${i?.duration}`)
};

/**
* | output |
* | --- |
* | "Timer: {duration}" |
*
* @param {Editor_Step_TimerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_timer = /** @type {((inputs: Editor_Step_TimerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_TimerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_timer(inputs)
	return en_editor_step_timer(inputs)
});